import { useMemo } from "react";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves box number data.
 * @returns - A promise that resolves to the bus division data.
 */
export const useFetchBusDivisions = () => {
  const memoizedFetchBusDivisions = useMemo(
    () => async () => {
      return apiGet("/busDivisions", "fetching Bus Divisions");
    },
    []
  );

  return memoizedFetchBusDivisions;
};
